import { inject, Injectable, signal } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { StaticSettings } from './static-settings';
import { UserLegalDocumentsAcceptance } from '../interfaces/user-legal-documents-acceptance';
import { UserInfo } from '../interfaces/user-info';

@Injectable({ providedIn: 'root' })
export class UserSelfService {
  public systemName: string = 'AMCMobile';
  private readonly _userInfo = signal<UserInfo>(null);
  userInfo = this._userInfo.asReadonly();

  private readonly _http = inject(HttpClient);
  private readonly _settings = inject(StaticSettings);

  getUserInfo() {
    if (this._userInfo()) return of(this._userInfo());

    const endpointUrl = this._settings.getApiUrl('UserCenter/userInfo');
    return this._http
      .get<UserInfo>(endpointUrl)
      .pipe(tap(userInfo => this._userInfo.set(userInfo)));
  }

  public getUserLegalDocumentsAcceptance(): Observable<UserLegalDocumentsAcceptance> {
    const endpointUrl = this._settings.getApiUrl('user/me/acceptances');

    return this._http.get<UserLegalDocumentsAcceptance>(endpointUrl);
  }

  public getTemplateIsRead(templateName: string): Observable<any> {
    let params = new HttpParams();
    params = params.set('templateName', templateName);
    params = params.set('system', this.systemName);
    const endpointUrl = this._settings.getApiUrl(`UserVersionReadHistory/GetTemplateVersionIsRead`);
    return this._http.get<any>(endpointUrl, { params });
  }

  public setTemplateIsRead(templateName: string): Observable<any> {
    const endpointUrl = this._settings.getApiUrl(
      `UserVersionReadHistory/SetTemplateVersionRead?templateName=${templateName}&system=${this.systemName}`
    );
    return this._http.post(endpointUrl, null);
  }

  public getLocalizationTemplate(
    tenantId: string,
    templateName: string,
    cultureName: string
  ): Observable<any> {
    switch (tenantId) {
      case 'CH_FRENCH':
        tenantId = 'CH';
        break;
      case 'BELGIUM_FRENCH':
        tenantId = 'BE';
        break;
      case 'LUX_GERMAN':
        tenantId = 'LU';
        break;
    }
    const endpointUrl = this._settings.getApiUrl(
      `templateSettings/${tenantId}/${templateName}/localization/${cultureName}`
    );
    return this._http.get<any>(endpointUrl);
  }

  public getLocalizedLanguage(tenantId: string, templateName: string) {
    const endpointUrl = this._settings.getApiUrl(
      `templateSettings/${tenantId}/localization/${templateName}`
    );
    return this._http.get<string[]>(endpointUrl);
  }

  public updateUserLegalDocumentsAcceptance(
    acceptance: UserLegalDocumentsAcceptance
  ): Observable<any> {
    const endpointUrl = this._settings.getApiUrl('user/me/acceptances');

    return this._http.post<UserLegalDocumentsAcceptance>(endpointUrl, acceptance);
  }
}
